
const _ = require('lodash');
const ko = require('knockout');
const parseHTML = require('rgs-jquery').parseHTML;


// Adds `html` option to supply an html string instead of `nodes`

const template = ko.bindingHandlers.template;

ko.bindingHandlers.template = _.defaults({
	init: function (element, valueAccessor, ...args) {
		const fakeValueAccessor = function () {
			const bindingValue = ko.unwrap(valueAccessor());
			if (_.isObject(bindingValue) && 'html' in bindingValue) {
				const html = bindingValue['html'];
				if (!_.isString(html)) {
					throw new TypeError(
						'The "html" option must be a plain, non-observable html string.'
					);
				}
				return _.defaults({
					nodes: parseHTML(html),
				}, bindingValue);
			}
			return bindingValue;
		};
		return template.init(element, fakeValueAccessor, ...args);
	},
}, template);

